import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const FinancialYearList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;

  const { sendRequest: getDataList } = useHttp();

  const { sendRequest: deleteFinancialYear } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Holidays detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          serviceId: serviceId,
          
        };

        deleteFinancialYear(
          {
            url: "/api/financialYear/",
            method: "Delete",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/financialYear/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
            console.log("data", res)
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Financial Year Detail{" "}
            </label>{" "}
          </div>
          <div className="col-4"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.sId(serviceId || 0);
                props.update(false);
              }}
            >
              Add Financial Year
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Financial Year Name</th>
                            <th>Status</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.createdDate}</td>
                                <td>{x.financialYearName}</td>

                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.sId(serviceId || 0);
                                      props.addForm(true);
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => deleteOperation(e, x)}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FinancialYearList;
